import { Toggle } from "@certn/cascadia-react";
import { useFormikContext } from "formik";

import { Schemas } from "../types";

export type NameOptOutField = "has_no_additional_name" | "has_no_family_name";
type OptOutNameField = "additional_name" | "family_name";

interface Props {
  optOutField: NameOptOutField;
  nameField: OptOutNameField;
  testID: string;
  children: string;
}

export function NameOptOutToggle(props: Props) {
  const { values, setFieldValue, setFieldTouched } =
    useFormikContext<Schemas["CreatePersonalProfile"]>();

  return (
    <Toggle
      isSelected={values[props.optOutField] === true}
      onChange={(isSelected) => {
        void setFieldValue(props.optOutField, isSelected);
        if (isSelected) {
          void setFieldValue(props.nameField, "", false);
          void setFieldTouched(props.nameField, false, false);
        }
      }}
      testID={props.testID}
    >
      {props.children}
    </Toggle>
  );
}
